import React, {useEffect} from 'react';
import LandingHeader from '../components/landing/LandingHeader';
import LandingHero from '../components/landing/LandingHero';
import FeatureColumns from '../components/landing/FeatureColumns';
import CrossDeviceSection from '../components/landing/CrossDeviceSection';
import IntelligenceSections from '../components/landing/IntelligenceSections';
import SecurityBand from '../components/landing/SecurityBand';
import LandingCta from '../components/landing/LandingCta';
import LandingFooter from '../components/landing/LandingFooter';
import {appName} from '../components/landing/content';
import {landingCta} from '../components/landing/cta';

/**
 * Публичная главная страница (`/`) — витрина продукта, открытая всем.
 *
 * Страница полностью статична: ни одного запроса к API и ни одного обращения к
 * данным пользователя (см. requirements.md, SEC-1/SEC-2). Авторизованный
 * пользователь тоже может её открыть: от анонимной версии она отличается только
 * набором CTA (`components/landing/cta.ts`) — вместо регистрации и входа ведёт
 * в приложение. Флаг сессии приходит пропом из `App.tsx`: сама страница про
 * аутентификацию ничего не спрашивает и в API не ходит.
 */
const LandingPage: React.FC<{authenticated?: boolean}> = ({authenticated = false}) => {
    const cta = landingCta(authenticated);

    useEffect(() => {
        const previous = document.title;
        document.title = `${appName()} — гардероб, который умеет думать`;
        return () => {
            document.title = previous;
        };
    }, []);

    // overflow-x-clip: декоративные слои (мокап телефона за краем колонки) не должны
    // давать странице горизонтальный скролл; clip, а не hidden — корень не становится
    // прокручиваемым контейнером и не ломает sticky-шапку.
    return (
        <div className="min-h-screen overflow-x-clip bg-[#f6f7f9] dark:bg-ink-950" data-testid="landing-page">
            <LandingHeader cta={cta}/>
            <main>
                <LandingHero cta={cta}/>
                {/* Ритм страницы задаётся расстояниями, а не одинаковыми карточками:
                    после плотного hero — воздух вокруг утверждения, дальше витрина
                    данных, тёмная полоса о доверии и финальный призыв. */}
                <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 space-y-20 md:space-y-28 pb-20 md:pb-28">
                    <FeatureColumns/>
                    <CrossDeviceSection/>
                    <IntelligenceSections cta={cta}/>
                    <SecurityBand/>
                    <LandingCta cta={cta}/>
                </div>
            </main>
            <LandingFooter cta={cta}/>
        </div>
    );
};

export default LandingPage;
